import { Fragment } from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { SubTaskTitle, SectionTitle } from '../../Styles';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { getIssueStatusForClient } from 'shared/constants/issues';
import { useLocation, useNavigate } from 'react-router-dom';
import logger from 'utils/logger';

const log = logger.createLogger('ProjectBoardIssueDetailsChildrenIssues');

const propTypes = {
  childrenIssues: PropTypes.arrayOf(PropTypes.object),
  setNewChildIssueModalOpen: PropTypes.func.isRequired,
  parentIssue: PropTypes.object,
  canCreateLinkedIssue: PropTypes.bool.isRequired,
  canCheckParentIssue: PropTypes.bool,
};

// Adding subtasks to the issue
const IssueDetailsLinkedIssues = ({
  childrenIssues,
  parentIssue,
  setNewChildIssueModalOpen,
  canCreateLinkedIssue,
  canCheckParentIssue,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleAddSubTask = () => {
    setNewChildIssueModalOpen(true);
  };

  const generateParentIssueUrl = () => {
    const isInTaskManagement = location.pathname.includes(
      '/dashboard/task-management'
    );
    if (isInTaskManagement) {
      return `/dashboard/task-management/task-management-regular/issues/${parentIssue.id}`;
    } else {
      return `/dashboard/history/received/issues/${parentIssue.id}`;
    }
  };

  return (
    <Fragment>
      <Grid container alignItems="center" sx={{ mb: 2, mt: 2 }}>
        <Grid size={6}>
          <SubTaskTitle>
            {intl.get('issue_details_text_linked_issues')}
          </SubTaskTitle>
        </Grid>
        <Grid size={6}>
          <Tooltip
            title={
              !canCreateLinkedIssue
                ? intl.get('issue_details_tooltip_disabled_add_child_issue')
                : ''
            }
            arrow>
            <span>
              <Button
                variant="primary"
                icon="issues"
                iconSize={20}
                sx={{ justifyContent: 'start' }}
                disabled={!canCreateLinkedIssue}
                onClick={handleAddSubTask}>
                {intl.get('issue_details_button_add_child_issue')}
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </Grid>

      <SectionTitle>
        {intl.get('issue_details_text_children_issues')}
      </SectionTitle>
      {childrenIssues &&
        childrenIssues.map((issue, index) => {
          return (
            <div key={index}>
              <Button
                variant="success"
                sx={{ justifyContent: 'start' }}
                onClick={() => {
                  //! This navigation will always be sent as you sent the issue
                  navigate(`/dashboard/history/sent/issues/${issue.id}`);
                }}>{`${issue.title} [${getIssueStatusForClient(
                issue.status
              )}]`}</Button>
            </div>
          );
        })}

      <SectionTitle>{intl.get('issue_details_text_parent_issue')}</SectionTitle>
      {canCheckParentIssue && (
        <Button
          variant="secondary"
          sx={{ justifyContent: 'start' }}
          onClick={() => {
            navigate(generateParentIssueUrl());
          }}>{`${parentIssue.title} [${getIssueStatusForClient(
          parentIssue.status
        )}]`}</Button>
      )}
    </Fragment>
  );
};

IssueDetailsLinkedIssues.propTypes = propTypes;

export default IssueDetailsLinkedIssues;
